import { setInvestigationStatuses } from '@customer/store/slices/filtersSlice';
import { useTranslation } from 'react-i18next';
import { FilterInputProps } from '@customer/filters/types';
import { MultiselectFilter } from './MultiselectFilter';
import { useMemo } from 'react';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { InvestigationStatus } from '@customer/store/apis/investigationsApi';
import { TranslationNamespaceBackend } from '@cas/utils/translationHelpers';

const useInvestigationStatusOptions = (): DropdownItemProps<InvestigationStatus>[] => {
  const { t } = useTranslation();

  return useMemo(() => {
    return Object.values(InvestigationStatus)
      .map(sts => {
        const stringValue = sts.toString();
        return {
          key: stringValue,
          value: sts,
          stringValue,
          label: t(`Enum.InvSts.${sts}`, { ns: TranslationNamespaceBackend }),
        };
      })
      .sort((a, b) => a.label.localeCompare(b.label));
  }, [t]);
};

export const InvestigationStatusesFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicDropdownMultiselectElement>) => {
  const { t } = useTranslation();

  return (
    <MultiselectFilter<InvestigationStatus>
      filterName="investigationStatuses"
      label={label ?? t('InvestigationStatus')}
      action={setInvestigationStatuses}
      elementRef={elementRef}
      useItemsHook={useInvestigationStatusOptions}
    />
  );
};

export default InvestigationStatusesFilter;
